import React from 'react';
import PropTypes from 'prop-types';
import { Sidebar } from 'semantic-ui-react';

const SidebarNav = ({
  children,
  sidebar,
  visible,
  onClose,
}) => (
  <Sidebar.Pushable>
    {sidebar}
    <Sidebar.Pusher dimmed={visible} className={`${visible ? 'no-scoll' : ''} app`} onClick={onClose}>
      {children}
    </Sidebar.Pusher>
  </Sidebar.Pushable>
);

SidebarNav.propTypes = {
  children: PropTypes.node,
  sidebar: PropTypes.node,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

export default SidebarNav;



// WEBPACK FOOTER //
// ./src/components/Sidebar.jsx